import React from 'react'
import {ITableProps} from "@ui/tableCustom/types/table";
import LocalFilters from "@ui/tableCustom/containers/localFilters/LocalFilters";
import TableFeatures from "@ui/tableCustom/tableFeatures/TableFeatures";


function TableCustom<T>({
                            isLoading,
                            isError,
                            mapperRowCb,
                            data,
                            fullColumns,
                            headColumns,
                            totalPage,
                            params,
                            hasLocalFilters = false,
                            disabled,
                            hasExport = true,
                            hasPdfExport = true,
                            exportParams,
                            autoGenerateExportData = ['data'],
                            mapperColumnCb,
                            baseExportStyles,
                            headSideBar,
                            secondarySidebar,
                            headerExportContents,
                            initialStickyHeader,
                            generateExportExcelRowStylesCb,
                            generateExportExcelHeadColumnStylesCb,
                            changeExportSidebarSettings,
                            localFiltersProps,
                            sx,
                            lastTableRow,
                            menuSettingsTable,
                            hasModalFullScreen,
                            paginationProps,
                        }: ITableProps<T>) {

    if (hasLocalFilters) {
        return (
            <LocalFilters
                <T>
                isLoading={isLoading}
                isError={isError}
                mapperRowCb={mapperRowCb}
                fullColumns={fullColumns}
                headColumns={headColumns}
                params={params}
                headSideBar={headSideBar}
                secondarySidebar={secondarySidebar}
                disabled={disabled}
                hasExport={hasExport}
                exportParams={exportParams}
                autoGenerateExportData={autoGenerateExportData}
                mapperColumnCb={mapperColumnCb}
                baseExportStyles={baseExportStyles}
                data={data}
                headerExportContents={headerExportContents}
                initialStickyHeader={initialStickyHeader}
                generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
                generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
                changeExportSidebarSettings={changeExportSidebarSettings}
                paginationProps={paginationProps}
                localFiltersProps={localFiltersProps}
                hasPdfExport={hasPdfExport}
                sx={sx}
                lastTableRow={lastTableRow}
                menuSettingsTable={menuSettingsTable}
                hasModalFullScreen={hasModalFullScreen}
            />
        )
    }
    return (
        <TableFeatures
            <T>
            headerExportContents={headerExportContents}
            isLoading={isLoading}
            isError={isError}
            mapperRowCb={mapperRowCb}
            fullColumns={fullColumns}
            headColumns={headColumns}
            params={params}
            headSideBar={headSideBar}
            secondarySidebar={secondarySidebar}
            disabled={disabled}
            hasExport={hasExport}
            exportParams={exportParams}
            autoGenerateExportData={autoGenerateExportData}
            mapperColumnCb={mapperColumnCb}
            baseExportStyles={baseExportStyles}
            totalPage={totalPage}
            data={data}
            initialStickyHeader={initialStickyHeader}
            generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
            generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
            changeExportSidebarSettings={changeExportSidebarSettings}
            paginationProps={paginationProps}
            hasPdfExport={hasPdfExport}
            sx={sx}
            lastTableRow={lastTableRow}
            menuSettingsTable={menuSettingsTable}
            hasModalFullScreen={hasModalFullScreen}
        />
    )
}

export default TableCustom;